import {
  LayoutSchema,
} from './layoutTypes';
import defineLayoutSchema from './defineLayoutSchema';

const INTERNAL_PADDING = 4;
const EXTERNAL_PADDING = 10;

const layouSchemasMugWrapAround: LayoutSchema[] = [
  // right handed
  defineLayoutSchema('mwa_i1_1', 1, 1, 10, 0, 0, 0, undefined, 1, [
    [
      { width: 1, height: 1 },
    ],
  ], true),
  defineLayoutSchema('mwa_i1_2', 1, 1, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i2_1', 2, 1, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i3_1', 3, 1, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i4_1', 2, 2, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i6_1', 3, 2, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i1t1_1', 2, 1, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 1, type: 'text' },
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i2t1_1', 4, 1, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 2, height: 1, type: 'text' },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i2t1_2', 2, 2, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 2, type: 'text' },
      { width: 1, height: 1 },
    ],
    [
      {},
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i3t1_1', 4, 2, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 2, height: 2, type: 'text' },
      { width: 1, height: 1 },
      { width: 1, height: 2 },
    ],
    [
      {},
      {},
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i4t1_1', 4, 2, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 2, height: 2, type: 'text' },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
    [
      {},
      {},
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i6t1_1', 4, 2, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 2, height: 1, type: 'text' },
    ],
  ], false),
  defineLayoutSchema('mwa_i6t1_2', 4, 2, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
    [
      { width: 1, height: 1 },
      { width: 2, height: 1, type: 'text' },
      { width: 1, height: 1 },
    ],
  ], false),
  defineLayoutSchema('mwa_i6t1_3', 4, 2, 10, INTERNAL_PADDING, EXTERNAL_PADDING, 0, undefined, 1, [
    [
      { width: 1, height: 1 },
      { width: 2, height: 1, type: 'text' },
      { width: 1, height: 1 },
    ],
    [
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
      { width: 1, height: 1 },
    ],
  ], false),
];

export default layouSchemasMugWrapAround;
